var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},_vm._l((_vm.items),function(tab){return _c('div',{key:tab.value,staticClass:"tab",class:{ active: _vm.value === tab.value },on:{"click":function($event){return _vm.$emit('input', tab.value)}}},[_vm._v(_vm._s(tab.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }